import httpFetch from '../common/httpFetch/httpFetch';
import { backendServer } from '../common/config';
import { TeamMember } from '../models/TeamMember';
import { Page } from '../models/Page';
import { TeamMemberLifecycleEvent } from '../models/TeamMemberLifecycleEvent';
import { TeamMemberLifecycleSnapshot } from '../models/LifecycleSnapshot';
import { Invitation } from '../models/Invitation';
import { TeamMemberStatistics } from '../models/TeamMemberStatistics';

export const fetchTeamMembers = async (page = 0, sort: string, sortDirection: string, ...rest: unknown[]): Promise<Page<TeamMember>> => {
  const params = new URLSearchParams();
  params.append('page', String(page));
  if (sort) {
    params.append('sort', `${sort},${sortDirection}`);
  }
  const response = await httpFetch(`${backendServer()}/teams/default/members?${params.toString()}`, {
    method: 'GET',
  });
  return response.json();
};

export const fetchTeamMembersStatistics = async (...rest: unknown[]): Promise<TeamMemberStatistics> => {
  const response = await httpFetch(`${backendServer()}/teams/default/members/statistics`, {
    method: 'GET',
  });
  return response.json();
};

export const fetchCurrentInvitation = async (teamMember: TeamMember, ...rest: unknown[]): Promise<Invitation> => {
  const response = await httpFetch(`${backendServer()}/teams/default/members/${teamMember.id}/invitations/current`, {
    method: 'GET',
  });
  return response.json();
};

export const fetchInvitation = async (teamMemberId: string, invitationId: string, ...rest: unknown[]): Promise<Invitation> => {
  const response = await httpFetch(`${backendServer()}/teams/default/members/${teamMemberId}/invitations/${invitationId}`, {
    method: 'GET',
  });
  return response.json();
};

export const addTeamMember = async (teamMember: TeamMember): Promise<TeamMember> => {
  const response = await httpFetch(`${backendServer()}/teams/default/members`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    body: JSON.stringify(teamMember),
  });
  return response.json();
};

export const updateTeamMember = async (teamMember: TeamMember): Promise<TeamMember> => {
  const response = await httpFetch(`${backendServer()}/teams/default/members/${teamMember.id}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    body: JSON.stringify(teamMember),
  });
  return response.json();
};

export const deleteTeamMember = async (teamMemberId: string): Promise<void> => {
  await httpFetch(`${backendServer()}/teams/default/members/${teamMemberId}`, {
    method: 'DELETE',
  });
};

export const performLifecycleTransition = async (teamMemberId: string, event: TeamMemberLifecycleEvent): Promise<TeamMemberLifecycleSnapshot> => {
  const response = await httpFetch(`${backendServer()}/teams/default/members/${teamMemberId}/lifecycle`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    body: JSON.stringify(event),
  });
  return response.json();
};
